import React from 'react';
import logo from '../../assets/footer_logo.png';
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {

    const footerMenu = [
        {
            'name' : 'Sobre nós',
            'link' : '/'
        },
        {
            'name' : 'Serviços Dentários',
            'link' : '/'
        },
        {
            'name' : 'Dentista',
            'link' : '/'
        },
        {
            'name' : 'Blogs',
            'link' : '/'
        },
        {
            'name' : 'FAQs',
            'link' : '/'
        }
    ];

    const footerContacts = [
        {
            'title': 'Número de telefone',
            'info': '+244 283 366 / 929 059 545',
            'icon': call
        },
        {
            'title': 'Horário de Funcionamento',
            'info': '09:00 AM - 18:00 PM',
            'icon': time
        },
        {
            'title': 'Clinic Address',
            'info': 'Rua Comandante Gika, Largo da Sagrada Família, N .315, Rés do chão.',
            'icon': location
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <p>A Odonto Care é uma clínica local de referência em estética dentária, prevenção e tratamentos restauradores em Luanda.</p>

                        <div className="social-logo">
                            <p>Siga-nos em</p>
                            <ul>
                                <li><a href="https://www.facebook.com/odontocareangola" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                                <li><a href="/"><FaTwitter/></a></li>
                                <li>  <a href="https://www.instagram.com/odontocareangola/" target="_blank" rel="noopener noreferrer"><FaInstagram /> </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>Links Rápidos</p>
                            <ul>
                                {
                                    footerMenu.map(singleMenu => <li><Link to="/">{singleMenu.name}</Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>Contacto & Informações</p>

                            {
                                footerContacts.map(footerContact => {
                                    return  <div className="contact-list">
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt="call" />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; OdontoCare. 2026 Todos os Direitos Reservados </p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/'>Termos de Uso</Link></li>
                            <li><Link to='/'>Política de Privacidade</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;